const stickyBar = document.getElementById('sticky-atc');
const originalBtn = document.querySelector('form[action="/cart/add"] [type="submit"]');

// 元のボタンが見えているときはスティッキーバーを非表示
const observer = new IntersectionObserver(([entry]) => {
  stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
  
  // スティッキーバーが再表示されるときにボタンの色を元に戻す
  if (!entry.isIntersecting) {
    stickyBtn.style.background = '';
    stickyBtn.style.color = '';
  }
});
if (originalBtn) observer.observe(originalBtn);

// スティッキーボタンのクリック処理
const stickyBtn = document.getElementById('sticky-atc-btn');
if (stickyBtn) {
  stickyBtn.addEventListener('click', function() {

    // 押下フィードバック（一瞬白く）
    stickyBtn.style.transition = 'background 0.15s ease, color 0.15s ease';
    stickyBtn.style.background = '#ffffff';
    stickyBtn.style.color = '#000000';

    setTimeout(() => {
      if (originalBtn) {
        originalBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 150);

  });
}

// Chromeスマホのブラウザバー対応
if (window.visualViewport) {
  const adjustStickyBar = () => {
    const bottomOffset = window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop;
    stickyBar.style.bottom = Math.max(0, bottomOffset) + 'px';
  };
  window.visualViewport.addEventListener('resize', adjustStickyBar);
  window.visualViewport.addEventListener('scroll', adjustStickyBar);
  adjustStickyBar();
}